import { CircularProgress } from '@mui/material';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import loading from '../../../../src/images/loading.gif';

const PrivateRoute = ({ children, ...rest }) => {

    const { user, isLoading } = useAuth();
    const spinnerStyle = {
        width: "3rem",
        height: "3rem"
    }
    if (isLoading) {
        <div className="text-center my-5 py-5">
            <div
                className="spinner-grow color-1 mt-5"
                style={spinnerStyle}
                role="status"
            >
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    }
    return (
        <Route
            {...rest}
            render={({ location }) =>
                user.email || user.displayName ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;